<template>
 <div class="myworks__list">
  <my-project-item v-for="project in projectList" v-bind:projectItem="project" :key="project.title">
  </my-project-item>
 </div>
</template>

<script>
 import MyProjectItem from '@/components/MyProjectItem.vue';

 export default {
  props: {
   projectList : NodeList
  },
  components: {
   MyProjectItem,
  }
 }
</script>

<style>
 .myworks__list {
  width: 80%;
  margin: 0 auto;
 }
 @media only screen and (max-width: 1000px) {
  .myworks__list {
   width: 90%;
  }
 }
</style>